/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-01-02",
    versionChannel: "nightly",
    buildDate: "2025-01-02T00:06:19.093Z",
    commitHash: "1d0576766c543d3267ed6e489035e8acba677232",
};
